export default async function enableIpPrueba(status) {
  // const endpoint = localStorage.getItem('endpoint')

  const url = "https://api.almeraim.com/securityairbytes/validate";

  const js = JSON.stringify(status);

  try {
    const config = { method: "POST", headers: {}, mode: "cors", body: js };
    const response = await fetch(url, config);
    const json = await response.json();

    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
